import { render, staticRenderFns } from "./job-ing.vue?vue&type=template&id=22440ea6&scoped=true"
import script from "./job-ing.vue?vue&type=script&lang=js"
export * from "./job-ing.vue?vue&type=script&lang=js"
import style0 from "./job-ing.vue?vue&type=style&index=0&id=22440ea6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22440ea6",
  null
  
)

export default component.exports